import { Link } from 'react-router-dom';

type Crumb = { label: string; to?: string };

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-1.5">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700" aria-current="page">
                {item.label}
              </span>
            )}
            {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}